import { render, staticRenderFns } from "./RatesTable.vue?vue&type=template&id=21f0f0c8&scoped=true"
import script from "./RatesTable.vue?vue&type=script&lang=js"
export * from "./RatesTable.vue?vue&type=script&lang=js"
import style0 from "./RatesTable.vue?vue&type=style&index=0&id=21f0f0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0f0c8",
  null
  
)

export default component.exports